import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
    container: {},
})

const Example: React.FC = () => {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <div />
        </div>
    )
}

export default Example
